var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.112 27h9.804c1.28 0 2.052-.69 2.105-1.928l.66-14.597h1.544c.425 0 .775-.35.775-.76 0-.409-.35-.748-.775-.748h-4.596V7.438C20.63 5.93 19.607 5 17.957 5h-3.906c-1.65 0-2.669.93-2.669 2.438v1.529H6.803c-.412 0-.772.34-.772.749 0 .42.36.76.772.76H8.36l.66 14.596C9.073 26.31 9.845 27 11.112 27zm2.134-19.462c0-.5.363-.84.917-.84h3.692c.557 0 .917.34.917.84v1.429h-5.526zm-.495 16.605c-.37 0-.626-.23-.64-.59l-.316-10.88c-.014-.35.247-.59.646-.59.363 0 .63.23.64.58l.31 10.89c.01.35-.247.59-.64.59zm3.27 0c-.393 0-.67-.24-.67-.59v-10.88c0-.35.277-.59.67-.59s.66.24.66.59v10.88c0 .35-.268.59-.66.59zm3.256 0c-.39 0-.65-.24-.637-.59l.307-10.88c.01-.36.28-.59.64-.59.392 0 .66.24.65.59l-.32 10.88c-.01.36-.268.59-.64.59z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.7334eaf6dc98e81fe8829cb44bd43479.svg";
export { ForwardRef as ReactComponent };